import { render, staticRenderFns } from "./AccountingTransactionLedgerReportList.vue?vue&type=template&id=0ba63d4c&"
import script from "./AccountingTransactionLedgerReportList.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionLedgerReportList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingTransactionLedgerReportList.vue?vue&type=style&index=0&id=0ba63d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports